$(() => {
	$(document).ready(function(){

		$('ul.cj-tabs li').click(function(){
			var tab_id = $(this).attr('data-tab');

			$('ul.cj-tabs li').removeClass('cj-current');
			$('.cj-tab-content').removeClass('cj-current');

			$(this).addClass('cj-current');
			$("#"+tab_id).addClass('cj-current');
		})

	})
});



// WEBPACK FOOTER //
// ./assets/scripts/customer-journey.js